import styled from 'styled-components'
import { BodyDefault } from '../typography/styled'

type ActiveProp = {
  disabled?:boolean,
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 6;
`

export const DropItem = styled.button<ActiveProp>`
  appearance: none;
  display: flex;
  padding: 8px 12px;
  box-sizing: border-box;
  justify-content: space-between;
  width: 238px;
  border: 0;
  background: transparent;
  opacity:${({disabled}) => disabled ? '0.5' : ''};
  align-items: center;
  &:hover{
    cursor: ${({disabled}) => disabled ? 'default' : 'pointer'};
    background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
  }
  &:active:not(:disabled){
    background-color: ${({theme}) => theme.isDark ? theme.palette[400] : theme.grey[200]};
    transition: 0.1s background-color ease-in-out;
  }
  &:focus-visible{
    outline: none;
    background: ${({theme}) => theme.isDark ? theme.palette[200] : theme.grey[100]};
    box-shadow: inset ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`
export const Divider = styled.div`
  border: ${({theme}) => `1px solid ${theme.palette[350]}`};
  width:237px;
  margin-top:4px;
  margin-bottom:4px;

  @media (max-width: 768px) {
    width: 100%;
  }
`
export const DropTitle = styled(BodyDefault)<{$danger?:boolean}>`
  color:${({theme, $danger}) => $danger ? theme.errors[600] : theme.palette[850]};
  margin-left:6px;
  text-align: left;
  overflow-wrap: anywhere;
`

export const DropGroup = styled.span`
  display: block;
  padding: 8px 12px 2px;
  color: ${({theme}) => theme.grey[700]};
  font-size: 11px;
  line-height: 1;
  text-transform: uppercase;
`

export const DropHint = styled.span`
  margin-left: 6px;
  color: ${({theme}) => theme.grey[700]};
  font-size: 12px;
  line-height: 16px;
  text-align: left;
`
